import React from 'react';
import { Box, ModalBody, Theme, useTheme, Text, Flex } from '@chakra-ui/react';
import { ChakraAvatar, ChakraTextareaField } from 'app/components/Core';
import { ChakraAvatarGroup } from 'app/components/ChakraAvatarGroup';
import { getAvatarImage } from 'app/utils/utils';
import {
  getAvatarColorsArray,
  getRandomColor,
} from 'app/components/Core/ChakraAvatar/utils';
import { useFormContext } from 'react-hook-form';
import { AddCollaboratorsFormData, CollaboratorChip } from '../types';

export interface AddCollaboratorDialogComponentProps {
  onClose: () => void;
  collaborators: CollaboratorChip[];
}

export const InviteCollaboratorsSummary: React.FC<AddCollaboratorDialogComponentProps> = ({
  collaborators,
}: AddCollaboratorDialogComponentProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddCollaboratorsFormData>();

  const firstUser = collaborators?.[0];

  const theme = useTheme<Theme>();
  const randomColor = getRandomColor(
    getAvatarColorsArray(theme),
    firstUser?.initials
  );

  return (
    <ModalBody>
      {collaborators.length === 1 ? (
        <Flex alignItems="center">
          <ChakraAvatar
            title={firstUser.displayName}
            key={firstUser.guid}
            src={getAvatarImage(firstUser.profileImages)}
            initials={firstUser.initials}
            colors={
              firstUser.avatarColors || {
                background: randomColor[200],
                text: randomColor[500],
              }
            }
            size="md"
            borderWidth="0.38px"
            mr={2}
          />
          <Text color="textSubdued" overflowWrap="anywhere">
            {firstUser.displayName}
          </Text>
        </Flex>
      ) : (
        <ChakraAvatarGroup
          maxGroupSize={14}
          users={collaborators}
          size="md"
          withTooltip
        />
      )}

      <Box pt={4}>
        <ChakraTextareaField
          label="Message"
          placeholder="Hey, come collaborate with me on Session..."
          isInvalid={Boolean(errors?.emailMessage?.message)}
          errorMessage={errors?.emailMessage?.message}
          width="100%"
          resize="none"
          wordBreak="break-word"
          data-testid="Message"
          {...register('emailMessage')}
        />
      </Box>
    </ModalBody>
  );
};
